// 供应商类型
export const supplierTypeList = [
  { name: '全部', id: '' },
  { name: '生产商', id: 101 },
  // { name: '代理商', id: 102 },
  { name: '流通商', id: 103 }
];

export const width = {
  labelWidth: 140,
  itemWidth: 200
};

// 申请状态 全部、待确认、申请驳回、确认通过
export const applyStatusList = [
  { name: '全部', id: 104 },
  { name: '待确认', id: 101 },
  { name: '申请驳回', id: 102 },
  { name: '确认通过', id: 103 }
];

// 订单查询申请状态 待确认、已确认、申请驳回、待支付、支付中、支付失败、资料初审
export const orderApplyStatusList = [
  { name: '全部', id: null },
  { name: '申请待确认', id: '205,217' },
  { name: '已确认', id: '218' },
  { name: '申请驳回', id: '219' },
  { name: '待支付', id: '208' },
  { name: '支付中', id: '209' },
  { name: '支付失败', id: '210' },
  { name: '资料初审', id: '206' }
];
// 资料复审时间 1 小于30， 2 大于等于30小于60， 3 大于等于60小于90， 4 大于等于90
export const reviewTimeOptionList = [
  { name: '全部', id: null },
  { name: '小于30', id: 1 },
  { name: '大于等于30小于60', id: 2 },
  { name: '大于等于60小于90', id: 3 },
  { name: '大于等于90', id: 4 }
];
// 审核状态：1 待审核 2 审核驳回 3 审核完成
export const auditStatusList = [
  { name: '全部', id: null },
  { name: '待审核', id: 1 },
  { name: '审核驳回', id: 2 },
  { name: '审核完成', id: 3 }
];

// 领导审核状态 0:未审核，1审核成功，2：审核失败
export const reportAuditStatusList = [
  { name: '全部', id: null },
  { name: '待审核', id: 0 },
  { name: '审核驳回', id: 2 },
  { name: '审核完成', id: 1 }
];

const confirmResult = [
  { name: '通过', id: 1 },
  { name: '驳回', id: 2 }
];

// 评价信息
export const evaluativeInfoTableLabel = [
  { label: '评价编码', param: 'evaluationCode', align: 'center', width: 130 },
  { label: '产品评价办法', param: 'evaluateMethodName', align: 'center', width: 200 },
  { label: '专业', param: 'specialtyName', align: 'center', width: 130 },
  { label: '产品类目', param: 'className', align: 'center', minWidth: 180, tooltip: true },
  {
    label: '覆盖范围', param: 'level', align: 'center', width: 130,
    render: ({ level }) => {
      return level && (level + '级');
    }
  },
  { label: '产品名称', param: 'productName', align: 'center', minWidth: 180, tooltip: true },
  {
    label: '初评检测费(元)', param: 'applyAmount', align: 'right', width: 110, render: ({ applyAmount }) => {
      return applyAmount.toFixed(2);
    }
  }
];

// 供应商服务能力
export const serviceabilityTableLabel = [
  { label: '信息类型', param: 'infoType', align: 'center', minWidth: 160 },
  { label: '信息名称', param: 'infoName', slot: 'infoName', align: 'center', minWidth: 160, tooltip: true },
  { label: '更新时间', param: 'infoUpdateDate', align: 'center', minWidth: 160 },
  { label: '状态', param: 'infoStatusDesc', align: 'center' },
  {
    label: '审核结果', param: 'result', align: 'center',
    render: ({ result }) => {
      return confirmResult.find(item => result === item.id)?.name || '未确认';
    }
  }
];
// 资质
export const qualificationsTableLabel = [
  { label: '证书类型', param: 'certName', align: 'center', minWidth: 160, tooltip: true },
  { label: '证书编号', param: 'certNo', align: 'center', minWidth: 160 },
  { label: '有效期结束时间', param: 'certExpireDate', align: 'center', minWidth: 160 },
  { label: '更新时间', param: 'certUpdateDate', align: 'center', minWidth: 160 },
  { label: '状态', param: 'certStatusDesc', align: 'center' },
  {
    label: '审核结果', param: 'result', align: 'center',
    render: ({ result }) => {
      return confirmResult.find(item => result === item.id)?.name || '未确认';
    }
  }
];

// 评价类型
export const creditRoundList = [
  { name: '全部', id: null },
  { name: '初评', id: 1 },
  { name: '复评', id: 0 }
];

// 专业
export const specialtyList = [
  { name: '全部', id: null },
  { name: '煤炭', id: '1' },
  { name: '化工', id: '2' },
  { name: '材料', id: '3' },
  { name: '设备', id: '4' },
  { name: '电仪', id: '5' },
  { name: '技术', id: '6' }
];